import { AnyAction } from "redux";

type CustomerId = string; // ex. traceair
type SiteId = string; // ex. traceair/debug

const ACL_RECEIVED = "ACL_RECEIVED";

export const receiveAcl = (acl: AclState): AnyAction => ({
  type: ACL_RECEIVED,
  payload: acl,
});

export type AclState = {
  systemLevel: string[];
  customerLevel: { [permissionId: string]: CustomerId[] };
  siteLevel: { [permissionId: string]: SiteId[] };
};

const defaultState = {
  systemLevel: [],
  customerLevel: {},
  siteLevel: {},
};

export default function acl(
  state: AclState = defaultState,
  action: AnyAction,
): AclState | null {
  switch (action.type) {
    case ACL_RECEIVED:
      return action.payload;
    default:
      return state;
  }
}
